// src/components/About/index.js
import React, { Component } from 'react';

import './style.css';

export default class About extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    // const { className, ...props } = this.props;
    return (
      <div>.</div>
      /*
      <div className={classnames('container', className)} {...props}>
        <div className={classnames('row')}>
          <aside className={classnames('col l4 m12 s12 sidebar z-depth-1')}>
            <div className={classnames('row')}>
              <div className={classnames('heading')}>
                <div className={classnames('feature-img')}>
                  <Link to="/about"><img src="assets/images/profile-img.jpg" className={classnames('responsive-img')} /></Link>
                </div>
                <div className={classnames('title col s12 m12 l9 right')}>
                  <h2>Jefferson Seide Molléri</h2>
                  <span>Doctorand / PhD Student</span>
                </div>
              </div>
            </div>
          </aside>

          <section className={classnames('col s12 m12 l8 section">
            <div className={classnames('row')}>
              <div className={classnames('section-wrapper z-depth-1')}>
                <div className={classnames('section-icon col s12 m12 l2')}>
                  <i className={classnames('fa fa-suitcase')}></i>
                </div>
                <div className={classnames('custom-content col s12 m12 l10')}>
                  <h2>Work Experience</h2>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>*/
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/About/index.js